import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, X } from "lucide-react";

export function SuccessPopup({ open, onClose, title = "Submitted", body = "Your request has been received." , code}) {
    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 z-[80] grid place-items-center bg-ink/40 p-6 backdrop-blur-sm"
                    onClick={onClose}
                    data-testid="success-popup"
                >
                    <motion.div
                        initial={{ opacity: 0, y: 20, scale: 0.98 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: 8, scale: 0.98 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        onClick={(e) => e.stopPropagation()}
                        className="relative w-full max-w-md overflow-hidden rounded-[24px] border border-ink/10 bg-white p-8"
                    >
                        <button
                            onClick={onClose}
                            className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full border border-ink/10 text-ink/70 hover:text-pink"
                            aria-label="Close"
                            data-testid="success-popup-close"
                        >
                            <X className="h-4 w-4" />
                        </button>
                        <div className="grid h-14 w-14 place-items-center rounded-full bg-pink/10">
                            <CheckCircle2 className="h-7 w-7 text-pink" />
                        </div>
                        <h3 className="mt-6 font-display text-[26px] font-semibold tracking-tight text-ink">{title}</h3>
                        <p className="mt-2 text-[14px] leading-relaxed text-slate-600">{body}</p>
                        {code && (
                            <div className="mt-6 rounded-2xl border border-ink/10 bg-slate-50 p-4">
                                <div className="text-[11px] uppercase tracking-[0.24em] text-slate-500">Request ID</div>
                                <div className="mt-1 font-display text-[20px] font-semibold text-ink">{code}</div>
                            </div>
                        )}
                        <button
                            onClick={onClose}
                            className="btn-primary mt-8 w-full justify-center"
                            data-testid="success-popup-ok"
                        >
                            Great, close this
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export function FormShell({ children, aside }) {
    return (
        <section className="bg-white py-20 md:py-24">
            <div className="container-x">
                <div className="grid grid-cols-1 gap-16 md:grid-cols-12">
                    <div className="md:col-span-7">{children}</div>
                    <div className="md:col-span-5">
                        <div className="sticky top-32 rounded-[24px] border border-ink/10 bg-slate-25 p-8 md:p-10">
                            {aside}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
